export const PARAGRAPH_CONTENT_TYPE = "PARAGRAPH_CONTENT_TYPE";
export const IMAGE_CONTENT_TYPE = "IMAGE_CONTENT_TYPE";
export const LOGO_CONTENT_TYPE = "LOGO_CONTENT_TYPE";
export const VIDEO_CONTENT_TYPE = "VIDEO_CONTENT_TYPE";
